import { loadPipeline, setContextualSupport, unsetContextualSupport } from 'js/actions';
import { GET_PIPELINES_REQUEST } from 'js/constants/actionTypes';
import { ROUTE_PIPELINES, ROUTE_REDESIGN } from 'js/constants/pathnames';
import { getResourceEntity } from 'js/lib/PipelineUtils';
import UIUtils from 'js/lib/UIUtils';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { connect } from 'react-redux';
import PipelineForm from './PipelineForm';
import { ModalFilePreview } from 'new/elements/ModalFilePreview';
import { ModalReingest } from 'new/elements/ModalReingest';
import { ModalMoveToProject } from 'new/elements/ModalMoveToProject';

const mapStateToProps = (state, ownProps) => {
  const {
    entities,
    pipelines: {
      detailView: { id: selectedCardID },
    },
    dataSets: { lastAddedId: lastAddedDataSetId },
    sinks: { lastAddedId: lastAddedSinkId },
    request,
  } = state;
  const { flowNodes } = entities;
  const flowNodeId = UIUtils.extractParamFromURL(ownProps.match);
  const flowNode = flowNodes[flowNodeId];
  const source = getResourceEntity(flowNode, entities);

  const isLoadingPipelines = !!request[GET_PIPELINES_REQUEST];

  return {
    flowNodeId,
    source,
    isLoadingPipelines,
    selectedCardID,
    lastAddedDataSetId,
    lastAddedSinkId,
  };
};

const PipelineFormContainer = connect(mapStateToProps, {
  loadPipeline,
  setContextualSupport,
  unsetContextualSupport,
})(PipelineForm);

PipelineFormContainer.screenConfig = {
  screenName: 'PipelineFormContainer',
  domain: 'integrate',
  pageTitle: 'Flow',
  modals: [ModalFilePreview, ModalReingest, ModalMoveToProject],
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_PIPELINES}/:id/edit`,
};

export default PipelineFormContainer;
